"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMToolEndpoints = void 0;
var PMToolEndpoints;
(function (PMToolEndpoints) {
    PMToolEndpoints["TEMPLATES_GET"] = "/templates";
    PMToolEndpoints["TEMPLATES_UPDATE"] = "/templates/update";
    PMToolEndpoints["TEMPLATES_CREATE"] = "/templates/create";
    PMToolEndpoints["PROJECT_TEMPLATES_GET"] = "/templates/project";
    PMToolEndpoints["PROJECT_TEMPLATES_CREATE"] = "/templates/project/create";
    PMToolEndpoints["PROJECT_TEMPLATES_UPDATE"] = "/templates/project/update";
    PMToolEndpoints["ASSETS_EXCLUSIVE_GET"] = "/assets/exclusive";
    PMToolEndpoints["USER_GET"] = "/user";
    PMToolEndpoints["USER_UPDATE"] = "/user/update";
    PMToolEndpoints["USER_CREATE"] = "/user/create";
    PMToolEndpoints["STORY_GET"] = "/story";
    PMToolEndpoints["STORY_UPDATE"] = "/story/update";
    PMToolEndpoints["STOTY_GENERATE"] = "/story/generate";
})(PMToolEndpoints = exports.PMToolEndpoints || (exports.PMToolEndpoints = {}));
//# sourceMappingURL=PMTool.js.map